// extracted by mini-css-extract-plugin
module.exports = {"constrainedWidth":"style-module__constrainedWidth___1Ygic","studyScheduleOverrides":"style-module__studyScheduleOverrides___1L88m"};